import { i18nTranslationHelper } from '@/i18n'
import PathConstants from '../path-contants'

const getCompanyManagerPaths = (): PathConstants.RoutesProps => {
  const t = i18nTranslationHelper.getTPage

  return {
    COMPANY_MANAGER_DASHBOARD: {
      value: '/admin/dashboard',
      name: 'company_manager_dashboard',
      title: t('companyManager.dashboard.pageTitle')
    },
    COMPANY_MANAGER_CREATE_USER_PROFILE: {
      value: '/admin/user',
      name: 'company_manager_create_user_profile',
      title: t('companyManager.createUserProfile.pageTitle')
    },
    COMPANY_MANAGER_EDIT_USER_PROFILE: {
      value: '/admin/user/:accountId/profile',
      name: 'company_manager_edit_user_profile',
      title: t('companyManager.editUserProfile.pageTitle'),
      computeValue: args => `/admin/user/${args.accountId}/profile`
    },
    COMPANY_MANAGER_EDIT_DEPENDENT_USER_PROFILE: {
      value: '/admin/dependent_user/:accountId/profile',
      name: 'company_manager_edit_dependent_user_profile',
      title: t('companyManager.editDependentUserProfile.pageTitle'),
      computeValue: args => `/admin/dependent_user/${args.accountId}/profile`
    },
    COMPANY_MANAGER_DEPENDENT_LIST: {
      value: '/admin/dependent-user',
      name: 'company_manager_dependent_list',
      title: t('companyManager.dependentList.pageTitle')
    },
    COMPANY_MANAGER_HOLDER_SEARCH: {
      value: '/admin/holder-user/search',
      name: 'company_manager_holder_search',
      title: t('companyManager.holderSearch.pageTitle')
    },
    COMPANY_MANAGER_DEPENDENT_REGISTRATION: {
      value: '/admin/holder-user/:accountId/dependent',
      name: 'company_manager_dependent_registration',
      title: t('companyManager.dependentRegistration.pageTitle'),
      computeValue: args => `/admin/holder-user/${args.accountId}/dependent`
    },
    COMPANY_MANAGER_REQUESTS_CONFIGURATION: {
      value: '/admin/requests/configuration',
      name: 'company_manager_requests_configuration',
      title: t('companyManager.requestsConfiguration.pageTitle')
    },
    COMPANY_MANAGER_DEPENDENT_ENROLLMENT: {
      value: '/admin/dependent-enrollment',
      name: 'company_manager_dependent_enrollment',
      title: t('companyManager.dependentEnrollment.pageTitle')
    },
    COMPANY_MANAGER_UPGRADE_ENROLLMENT: {
      value: '/admin/upgrade-enrollment',
      name: 'company_manager_upgrade_enrollment',
      title: t('companyManager.upgradeEnrollment.pageTitle')
    }
  }
}

export default getCompanyManagerPaths
